import { UnionSmallIcon } from "@images/svgIcons/unionSmallIcon"
import { cn } from "@modules/lib/utils"
import { Text } from "@/components/ui/baseUi/text"

type BoxFormHeaderProps = {
  title: string
  subtitle?: string
  description?: string
  classname?: string
  children?: React.ReactNode
} & React.ComponentProps<"div">

export function BoxFormHeader({ title, subtitle, description, classname, children, ...props }: BoxFormHeaderProps) {
  return (
    <div
      className={cn("flex flex-col items-center gap-2 text-center", classname)}
      style={{ maxWidth: "45rem" }}
      {...props}
    >
      <UnionSmallIcon color="var(--color-white)" />
      <Text fontStyle="HL" className="mt-5">
        {title}
      </Text>
      {subtitle && <Text fontStyle="HL">{subtitle}</Text>}
      {description && (
        <Text
          fontStyle="BL"
          className="text-neutral-600"
          style={{ whiteSpace: "break-spaces", overflowWrap: "break-word" }}
        >
          {description}
        </Text>
      )}
      {children}
    </div>
  )
}
